package com.loyola.acessoescola.ui.adminpanel

data class AdminPanelState(
    val activeLogEntry: Int? = null,
    val fullName: String = "",
    val cpf: String = "",
    val bound: String = "",
    val phone: String = "",
    val photoUrl: String = "",
    val isLogsLoading: Boolean = true,
    val errorMessage: String = ""
)
